module.exports = __webpack_public_path__ + "static/ai-head-07bbb41de65ba56f20da8f271452879e.svg";